import "@app/styles/error-page.css";

import TMLogo from "@assets/tm_logo.webp";
import useRemoveOverlay from "@hooks/useRemoveOverlay";
import type { ReactElement } from "react";

export default function NotFound(): ReactElement {
  useRemoveOverlay();
  return (
    <>
      {/* <div className="flex flex-col items-center mt-[150px]">
        <h1 className="text-md lg:text-lg">
          Sorry, the page you visited no longer exists.
        </h1>
        <p className="text-md lg:text-lg">
          Please visit our{" "}
          <span>
            <a href="/" className="text-red-100">
              Home Page
            </a>
          </span>
        </p>
      </div> */}

      <div className="error-page not-found-page">
        <div id="container">
          <div className="white-container">
            <div className="center">
              <h1>
                <img
                  src={TMLogo}
                  className="logo center img-responsive"
                  alt="தமிழ் முரசு"
                />
              </h1>
              <p className="title">Page not found</p>
              <p>Visit our home page instead</p>
              <div className="mt-6">
                <a href="https://www.tamilmurasu.com.sg" className="button">
                  Go to home Page
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
